import { ParticipantsGeoareaApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useParticipantsGeoAreaApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new ParticipantsGeoareaApi(configuration),
    [configuration]
  );
};
